import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container, LabelBox, Title, Info } from './styles'
import { QRCodeSVG } from 'qrcode.react'
import axios from 'axios'

const { REACT_APP_API_LOCAL } = process.env

const PrintQRCode = () => {
  const { id } = useParams<{ id: string }>()
  const [documentName, setDocumentName] = useState<string>('Carregando...')

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const response = await axios.get(`${REACT_APP_API_LOCAL}/documents/public/${id}`)
        setDocumentName(response.data.name || 'Documento Oficial')
      } catch (error) {
        setDocumentName('Documento Oficial')
      } finally {
        setTimeout(() => {
          window.print()
        }, 500)
      }
    }
    
    if (id) {
      fetchDocument()
    }
  }, [id])

  return (
    <Container>
      <LabelBox>
        <Title>{documentName}</Title>
        <QRCodeSVG 
          value={`${window.location.origin}/public/document/${id}`}
          size={150}
        />
        <Info>Aponte a câmera para verificar a autenticidade</Info>
      </LabelBox>
    </Container>
  )
}

export default PrintQRCode
